<template>
<!-- 司机-批量添加 -->
  <div class="box">
    <div class="searchBox" style="margin-bottom: 500px;">
      <div class="divStyle">
        <span>操作类型：</span>
        <el-select
          v-model="submit_data.operation"
          placeholder="请选择"
          clearable
          @change="selectChange($event,'operation')"
        >
          <el-option label="余额" value="balance"> </el-option>
          <el-option label="服务费(保险金)" value="insurance"> </el-option>
          <!-- <el-option label="保证金" value="bond"> </el-option> -->
          <!-- <el-option label="活动积分" value="activity_point"> </el-option> -->
          <el-option label="表现分" value="monitor_point"> </el-option>
          <!-- <el-option label="隐藏分" value="monitor_point"> </el-option> -->
          <!-- <el-option label="星级分" value="star_point"> </el-option> -->
          <!-- <el-option label="优享券" value="priority_coupon"> </el-option> -->
        </el-select>
      </div>
      <div class="divStyle">
        <span>操作模式：</span>
        <el-select v-model="submit_data.mode" placeholder="请选择" clearable @change="selectChange($event,'mode')">
          <el-option label="增加" value="add"></el-option>
          <el-option label="减少" value="sub"> </el-option>
        </el-select>
      </div>
      <div class="batch">
        <el-upload
          style="width: 350px; height: 200px; line-height: 20px"
          class="upload-demo"
          drag
          :action="text_upload_url"
          :before-upload="beforeAvatarUpload"
          :headers="text_headers"
          :data="submit_data"
          :on-success="getExcelData"
          multiple
        >
          <div class="el-upload__text upload">
            将文件拖到此处，或<em>点击上传</em>
          </div>
        </el-upload>
      </div>
    </div>
  </div>
</template>

<script>
var _this;

import bus from "@/components/common/bus.js";
import { config } from "@/utils/config"; // 配置
export default {
  data() {
    return {
      excelData: [],
      progress_show: false,
      progress_data: 0,
      text_upload_url: config.axios_baseURL + "/driver/addDriverPointsSub",
      // 上传文件的请求头
      text_headers: {
        "city-tag": "",
        token: "",
        "hash-key": "",
        platform: "pc",
        "app-version": "admin",
        port: "admin",
        'service-tag':''
      },

      submit_data: {

        operation: "",
        mode: "",
      },
    };
  },
  created() {
    _this = this;
  },
   beforeDestroy() {
    bus.$off("getCity");
  },
  mounted() {
    // 通过 Event Bus
    bus.$on("getCity", (msg) => {
      _this.submit_data.city_code = sessionStorage.getItem("city_code");
      _this.submit_data.city_tag = JSON.parse(
        localStorage.getItem("city_tag")
      ).city_tag;

    });

  },
  methods: {
    selectChange(val,e){
      console.log(val,'val');
      if(e=='operation'){
        _this.submit_data.operation = val;
        console.log(_this.submit_data.operation);
      }
      if(e=='mode'){
        _this.submit_data.mode = val;
        console.log(_this.submit_data.mode);
      }
    },
    beforeAvatarUpload(file) {
      if (_this.submit_data.operation == "") {
        this.$message.error("请选择操作类型！");
        return false;
      }else if(_this.submit_data.mode == ""){
        this.$message.error("请选择操作模式！");
        return false;
      }
      // 添加请求头
      _this.text_headers["city-tag"] = localStorage.getItem("city_tag")
      _this.text_headers["service-tag"] = localStorage.getItem("service_tag")
      _this.text_headers.token = localStorage.getItem("access_token");
      _this.text_headers["hash-key"] = _this.$hash_key();
      
    },


    getExcelData(response, file, fileList) {
      console.log(response,'response');

      if(response.data.length==0){
        this.$message.success("批量操作全部成功！");
        return;

      }
      this.$message.error("符合条件数据已导入，异常数据见excel表格！");

      if (this.$route.path == "/batch") {
        // 导出excel的空数组中添加数据
        for (let i = 0; i < response.data.length; i++) {
          // 向excelData数组里添加
          _this.excelData.push({
            phone: response.data[i][0],
            num: response.data[i][1],
            remark: response.data[i][2],
            why: response.data[i][3],
          });
        }

        // 将数据导出execl
        _this.exportData();
        console.log(_this.excelData,'_this.excelData');

        // 清空数据
        _this.excelData = [];
      }
    },
    // 导出excel方法
    exportData() {
      const { export_json_to_excel } = require("@/vendor/Export2Excel");
      const tHeader = ["电话号", "数值","备注","失败原因"];
      const filterVal = ["phone", "num","remark","why"];
      const list = this.excelData;
      const data = this.formatJson(filterVal, list);
      export_json_to_excel(tHeader, data, "导入失败数据");
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },
};
</script>

<style scoped>
.batch {
  display: flex;
  justify-content: center;
  align-content: center;
}
.upload {
  padding-top: 30px;
}
.el-select {
  width: 150px;
  margin-right: 20px;
}
.divStyle {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  align-items: center;
}
</style>